// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_2wkm1-HB6uWw7YUq6YsBR0_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"id":2,"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d9481248","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"strictMath":"on","sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src.player/ui/events/events/special-election/preview.vue
// module id = 235
// module chunks = 0